// extracted by mini-css-extract-plugin
export default {"banner":"StatisticsBanner_banner__lF0N5","statistics":"StatisticsBanner_statistics__ASyqK","stat":"StatisticsBanner_stat__asm61","statLabel":"StatisticsBanner_statLabel__pDGCX"};